import { bindAssetFetcher } from '../interface/asset';
import {
    bindConfigAPI,
    bindConfigCache,
    bindConfigLog,
    bindConfigManifest,
    bindConfigRoute,
    injectConfigRoute,
} from '../interface/config';
import { IContainer } from '../interface/container';
import { injectENV, injectFetch } from '../interface/util';
import api from './api';
import asset from './asset';
import cache from './cache';
import log from './log';
import manifest from './manifest';
import route from './routes';

function _bindLog(container: IContainer): Promise<void> {
    const env = injectENV(container);
    const config = log(env);
    bindConfigLog(config, container);
    return Promise.resolve();
}

function _bindAPI(container: IContainer): Promise<void> {
    const env = injectENV(container);
    const config = api(env);
    bindConfigAPI([config], container);
    return Promise.resolve();
}

function _bindAsset(container: IContainer): Promise<void> {
    return new Promise(async function (resolve, reject) {
        try {
            const val = await asset();
            bindAssetFetcher(val, container);
            resolve();
        } catch (error) {
            reject(error);
        }
    });
}

function _bindConfig(container: IContainer): Promise<void> {
    return new Promise(async function (resolve, reject) {
        try {
            const fetcher = await injectFetch(container);
            const routeConfig = injectConfigRoute(container);
            const val = await manifest(fetcher, routeConfig);
            bindConfigManifest(val, container);
            resolve();
        } catch (error) {
            reject(error);
        }
    });
}

function _bindCache(container: IContainer): Promise<void> {
    bindConfigCache(cache, container);
    return Promise.resolve();
}

function _bindRoute(container: IContainer): Promise<void> {
    const env = injectENV(container);
    const bindVal = route(env);
    bindConfigRoute(bindVal, container);
    return Promise.resolve();
}

export function bind(container: IContainer): Promise<void> {
    return new Promise(async function (resolve, reject) {
        try {
            const binders: Array<(container: IContainer) => Promise<void>> = [
                _bindLog,
                _bindAPI,
                _bindCache,
                _bindRoute,
                _bindAsset,
                _bindConfig,
            ];

            for (const binder of binders) {
                await binder(container);
            }

            resolve();
        } catch (error) {
            const errorLog = `bind error: ${[error]}`;
            console.error(errorLog);
            reject(errorLog);
        }
    });
}
